import Vue from "vue";
import day from 'dayjs' // load on demand
import 'dayjs/locale/pt-br' // load on demand

var weekOfYear = require('dayjs/plugin/weekOfYear')
day.extend(weekOfYear)

var localizedFormat = require('dayjs/plugin/localizedFormat')
day.extend(localizedFormat)

day.locale(navigator.language.toLowerCase()) // use PTBR locale globally

// Vue.use(day);

Vue.prototype.$dayjs = day;
